import { CurrencyTokenType as n, CurrencyTokenAssetName as a } from "../../constants/currency.js";
import * as e from "yup";
const r = e.mixed().oneOf(Object.values(n)).default(n.Unspecified), s = e.mixed().oneOf(Object.values(a)).default(a.Unspecify), o = e.mixed().oneOf([...Object.values(n), null]).nullable().default(null), t = e.object({
  address: e.string().default("0x0"),
  amount: e.string().nullable().default("0"),
  assetName: e.string().default(""),
  decimals: e.number().default(0),
  image: e.string().default(""),
  imageLite: e.string().default(""),
  name: e.string().default(""),
  type: r
}).from("rewardTokenAddress", "address"), m = e.object({
  amount: e.string().default("0"),
  type: r
}), u = e.object({
  ratio: e.number().default(0),
  type: r.nullable(!1)
}).from("price", "ratio").from("currencyCode", "type").noUnknown(!0), i = t.from("currencyBalance", "amount").from("currencyCode", "type").noUnknown(!0), d = e.object({
  amount: e.string().nullable().default("0"),
  address: e.string().default("0x0"),
  assetName: e.string().default(""),
  decimals: e.number().default(0),
  image: e.string().default(""),
  imageLite: e.string().default(""),
  name: e.string().default(""),
  type: r
}).from("income", "amount").from("rewardInfo.decimal", "decimals").from("rewardInfo.rewardName", "assetName").from("rewardInfo.rewardTokenAddress", "address").from("rewardInfo.staticAssetKey.currency.image", "image").from("rewardInfo.staticAssetKey.currency.imageLite", "imageLite").from("rewardInfo.staticAssetKey.currency.name", "name").from("rewardInfo.staticAssetKey.currency.type", "type").noUnknown(!0), f = t.from("decimal", "decimals").from("rewardName", "assetName").from("staticAssetKey.currency.image", "image").from("staticAssetKey.currency.imageLite", "imageLite").from("staticAssetKey.currency.name", "name").from("staticAssetKey.currency.type", "type").noUnknown(!0);
export {
  f as currencyInfoSchema,
  d as currencyOffchainTokenSchema,
  s as currencyTokenAssetNameSchema,
  m as currencyTokenLiteSchema,
  i as currencyTokenRenamedSchema,
  t as currencyTokenSchema,
  o as currencyTokenTypeNullableSchema,
  r as currencyTokenTypeSchema,
  u as onChainTokenToUsdSchema
};
//# sourceMappingURL=currency.js.map
